// src/components/common/ClientHelpBar.js
import React from 'react';
import '../../pages/onboarding.css';

export default function ClientHelpBar() {
  const baseSrc = '/images/team/pi1.jpg';
  const [imgSrc, setImgSrc] = React.useState(baseSrc);
  const [imgError, setImgError] = React.useState(false);
  const [retried, setRetried] = React.useState(false);
  return (
    <>
      <style>{`
        @media (max-width: 900px) {
          .client-help-bar-container { display: none !important; }
        }
      `}</style>
      <div className="onboarding-footer client-help-bar-container" style={{ borderTop: '1px solid var(--border, #e5e7eb)', marginTop: 0 }}>
        <div className="footer-inner">
          {/* Advisor block on top */}
          <div className="footer-links" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
            {imgError ? (
              <div style={{ width: 72, height: 72, borderRadius: '50%', display: 'grid', placeItems: 'center', background: 'var(--surface, #f3f4f6)', color: 'var(--muted, #6b7280)', border: '1px solid var(--border, #e5e7eb)', fontWeight: 700 }} aria-hidden="true">PI</div>
            ) : (
              <img
                src={imgSrc}
                alt="Votre conseiller"
                style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', border: '1px solid var(--border, #e5e7eb)' }}
                onError={() => {
                  if (!retried) {
                    setRetried(true);
                    setImgSrc(baseSrc + '?v=' + Date.now());
                  } else {
                    setImgError(true);
                  }
                }}
                onLoad={() => setImgError(false)}
              />
            )}
            <div style={{ lineHeight: 1.4, textAlign: 'left', maxWidth: '300px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                <div className="footer-help-title" style={{ margin: 0, fontWeight: 700, fontSize: '1.05rem', color: 'var(--foreground, #111827)' }}>Léon</div>
                <span style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: 99, background: '#dcfce7', color: '#166534', fontWeight: 600, letterSpacing: '0.02em' }}>En ligne</span>
              </div>
              <div style={{ fontWeight: 500, color: 'var(--muted, #4b5563)', fontSize: '0.9rem', marginBottom: 4 }}>Votre conseiller dédié</div>
              <div className="footer-link" style={{ fontSize: '.85rem', color: 'var(--muted, #6b7280)', lineHeight: '1.4' }}>
                Une question sur votre projet ? Je suis à votre écoute pour vous accompagner personnellement.
              </div>
            </div>
          </div>

          {/* Contact lines below (onboarding style) */}
          <div className="footer-help" style={{ marginTop: 8 }}>
            <a className="footer-help-title" href="mailto:contact@infocolab.com" aria-label="Besoin d’aide ? Écrire un email">Besoin d’aide ?</a>
            <a className="footer-link" href="mailto:contact@infocolab.com" aria-label="Envoyer un email">contact@infocolab.com</a>
            <a className="footer-link" href="tel:+33769297963" aria-label="Appeler">07 69 29 79 63</a>
          </div>

          {/* Duplicate reassurance text block below contacts */}
          <div className="footer-links" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 8 }}>
            <div style={{ lineHeight: 1.2, textAlign: 'center' }}>
              <div className="footer-help-title" style={{ margin: 0 }}>À votre écoute</div>
              <div className="footer-link" style={{ fontSize: '.9rem' }}>Un conseiller vous répond rapidement</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
